import { render, staticRenderFns } from "./MedicalDetails.vue?vue&type=template&id=e9d1e78c"
import script from "./MedicalDetails.vue?vue&type=script&lang=js"
export * from "./MedicalDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports